<template>
    <comp-9-art-adherence :section="9" :page="50" :next="nextScreen" :nextDisabled="nextDisabled">
        <p>
            So far, we’ve hit you up with a ton of information about educating and protecting yourself. We just want to take a moment to check in on how
            committed you are to this whole thing…
        </p>
        <p>
            How committed are you to doing what it takes to promote your health while living with HIV?
        </p>
        <v-radio-group v-model="artCommitmentSelection" column>
            <v-radio v-for="commitmentLevel in commitmentLevels" :key="commitmentLevel.id" :label="commitmentLevel.text" :value="commitmentLevel"></v-radio>
        </v-radio-group>
    </comp-9-art-adherence>
</template>

<script>
import { sync } from 'vuex-pathify';
import { find, forEach } from 'lodash';

export default {
    data: function() {
        return {
            artCommitmentSelection: null
        };
    },
    computed: {
        artCommitmentLevel() {
            let selectedCommitmentLevel = find(this.commitmentLevels, 'selected');

            if (selectedCommitmentLevel) {
                return selectedCommitmentLevel;
            } else return null;
        },
        commitmentLevels: sync('section9/artCommitment'),
        nextScreen() {
            if (this.artCommitmentSelection) {
                return `/page/9/${this.artCommitmentSelection.nextScreen}`;
            }

            return null;
        }
    },
    methods: {
        nextDisabled() {
            return !this.artCommitmentSelection;
        }
    },
    watch: {
        artCommitmentSelection(newArtCommitmentSelection) {
            forEach(this.commitmentLevels, o => {
                if (o.id === newArtCommitmentSelection.id) {
                    o.selected = true;
                } else {
                    o.selected = false;
                }
            });
        }
    },
    mounted() {
        this.artCommitmentSelection = this.artCommitmentLevel;
    }
};
</script>
